itsoftApp.createModule("scrollActions", ["startLoad", "cookie"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;
    // const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    window.gsapLibraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    };

    const librariesDraggable = {
        gsapDraggable: {
            name: "draggable",
            queue: [],
            started: false,
            loaded: false,
            script: "/assets/scripts/gsap/Draggable.min.js"
        }
    };

    const initScrollActions = function (element, scrollTriggerFlag, cb) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger); // eslint-disable-line
                }
            }

                if (element.classList.contains("js-swiped")) {
                    let mm = gsap.matchMedia();
                    new itsoftApp.modules.startLoad.callback(
                        function () {
                            const closeButton = element.querySelector(".disclaimer__close-button");
                            
                            mm.add("(max-width: 1023px)", () => {
                                Draggable.create(closeButton, {
                                    trigger: element,
                                    type: "x",
                                    bounds: {
                                        minX: 0,
                                        maxX: 68
                                    }
                                });
                            });

                            mm.add("(max-width: 767px)", () => {
                                Draggable.create(closeButton, {
                                    trigger: element,
                                    type: "x",
                                    bounds: {
                                        minX: 0,
                                        maxX: 46
                                    }
                                });
                            });
                        },
                    librariesDraggable.gsapDraggable);
                }

                if (element.classList.contains("js-slider-cycle")) {
                    element.classList.add("js-gsap-added");
                }

                if (element.classList.contains("js-change-bg-header")) {
                    const pageHeader = document.querySelector(".page-header");
                    const disclaimer = document.querySelector(".disclaimer");
                    let headerHeight = itsoftApp.commonVars.headerHeight;
                    let darkElements = document.querySelectorAll(".js-dark");

                    let mm = gsap.matchMedia();

                    const changeBgToDark = function () {
                        pageHeader.classList.add("dark-palette");
                        disclaimer.classList.add("dark-palette");
                    }

                    const changeBgToTransparent = function () {
                        pageHeader.classList.remove("dark-palette");
                        disclaimer.classList.remove("dark-palette");
                    }
                    
                    if (darkElements.length > 0) {
                        Array.prototype.forEach.call(darkElements, function (darkEl) {
                            mm.add("(min-width: 1024px)", () => {
                                ScrollTrigger.create({
                                    trigger: darkEl,
                                    start: "top top+=" + headerHeight,
                                    end: "bottom top+=" + headerHeight,
                                    onEnter: function () {
                                        changeBgToDark();
                                    },
                                    onLeave: function () {
                                        changeBgToTransparent();
                                    },
                                    onEnterBack: function () {
                                        changeBgToDark();
                                    },
                                    onLeaveBack: function () {
                                        changeBgToTransparent();
                                    }
                                });
                            });

                            mm.add("(max-width: 1023px)", () => {
                                ScrollTrigger.create({
                                    trigger: darkEl,
                                    start: "top bottom",
                                    end: "bottom bottom",
                                    onEnter: function () {
                                        changeBgToDark();
                                    },
                                    onLeave: function () {
                                        changeBgToTransparent();
                                    },
                                    onEnterBack: function () {
                                        changeBgToDark();
                                    },
                                    onLeaveBack: function () {
                                        changeBgToTransparent();
                                    },
                                    // markers: true
                                });
                            });
                        })
                    }
                }

                // ScrollTrigger.clearScrollMemory(); // eslint-disable-line
                if (element.classList.contains("js-parallax")) {
                    const parallaxItems = element.querySelectorAll(".js-parallax-item");

                    parallaxItems.forEach(function (item) {
                        gsap.set(item, {
                            yPercent: 25
                        });
                    });

                    gsap.utils.toArray(parallaxItems).forEach(item => {
                        gsap.to(item, {
                            yPercent: 0,
                            ease: "none",
                            scrollTrigger: {
                                trigger: item.closest(".js-parallax-parent"),
                                end: "bottom center",
                                // start: "top bottom", // the default values
                                // end: "bottom top",
                                scrub: true,
                                // markers: true
                            }, 
                        });
                    });
                }

                if (element.classList.contains("js-batch")) {
                    const borderContainer = document.querySelector(".js-border-container");
                    const steps = element.querySelectorAll(".js-step");

                    borderContainer.classList.add("js-show-active");

                    let mm = gsap.matchMedia();
                    mm.add("(min-width: 1024px)", () => {
                        steps.forEach(function (step) {
                            gsap.set(step, {
                                autoAlpha: 0,
                                y: "-1rem"
                            });
                        });
                        
                        ScrollTrigger.batch(steps, {
                            start: "top bottom",
                            onEnter: batch => gsap.to(batch, {autoAlpha: 1, stagger:{each: 0.2, ease: "power.out"}, duration: 1, y: "0"})
                            // markers: true
                        });
                    });
                }

                if (element.classList.contains("js-circles")) {
                    // ScrollTrigger.clearScrollMemory();
                    let cbFlag = false;
                    let mm = gsap.matchMedia();
                    const scrollSection = element.querySelector(".js-scroll-section");
                    const firstSection = element.querySelector(".js-first-section");
                    const secondSection = element.querySelector(".js-second-section");
                    const circleLeft = element.querySelector(".js-circle-left");
                    const circleRight = element.querySelector(".js-circle-right");
                    const circleImages = element.querySelectorAll(".js-circle-image");
                    const svgWrappers = element.querySelectorAll(".js-svg-wrapper");
                    const text1 = element.querySelector(".js-text-1");
                    const useBtn = element.querySelector(".js-use-btn");
                    const imageFirst = element.querySelector(".js-image-first");
                    const imageSecond = element.querySelector(".js-image-second");

                    const firstSectionTextEls = element.querySelectorAll(".js-column-first-text");
                    const secondSectionTextEls = element.querySelectorAll(".js-column-second-text");

                    const pageHeader = document.querySelector(".page-header");
                    const disclaimer = document.querySelector(".disclaimer");

                    const getHeaderHeight = function () {
                        const height = itsoftApp.commonVars.headerHeight || itsoftApp.utils.getHeaderHeight();
                        return height;
                    }

                    const onUseBtnClick = function (evt) {
                        evt.preventDefault();
                        gsap.set(useBtn, {
                            transition: "none"
                        });

                        gsap.to(useBtn, {
                            opacity: 0,
                            pointerEvents: "none",
                            duration: 0.3
                        })

                        gsap.to(secondSectionTextEls, {
                            opacity: 1,
                            duration: 0.3,
                            pointerEvents: "auto"
                        });

                        gsap.to(firstSectionTextEls, {
                            opacity: 0,
                            duration: 0.3,
                            pointerEvents: "none"
                        });

                        gsap.to(imageFirst, {
                            opacity: 0,
                            pointerEvents: "none",
                            duration: 0.3
                        });

                        gsap.to(imageSecond, {
                            opacity: 1,
                            pointerEvents: "auto",
                            duration: 0.3
                        });

                        gsap.to(secondSection, {
                            pointerEvents: "none",
                            backgroundColor: "#FF9BAD",
                            zIndex: 3,
                            duration: 0.3
                        })
                    }

                    gsap.set(secondSectionTextEls, {
                        opacity: 0,
                        pointerEvents: "none"
                    });

                    gsap.set(imageSecond, {
                        opacity: 0,
                        pointerEvents: "none"
                    });

                    useBtn.addEventListener("click", onUseBtnClick);

                if (element.classList.contains("js-intro")) {
                    const batch = element.querySelector(".js-batch");
                    const steps = batch.querySelectorAll(".js-step");
                    const item1 = element.querySelector(".js-item-1");
                    const item2 = element.querySelector(".js-item-2");
                    const logo = element.querySelector(".js-logo");
                    const label = element.querySelector(".js-label");
                    const packs = element.querySelector(".js-packs");

                    steps.forEach(function (step) {
                        gsap.set(step, {
                            autoAlpha: 0,
                            y: "1rem"
                        });
                    });

                    gsap.set(logo, {autoAlpha: 0, scale: 1.2});
                    gsap.set(item1, {autoAlpha: 0, y: "-1rem"});
                    gsap.set(item2, {autoAlpha: 0, y: "1rem"});
                    gsap.set(label, {autoAlpha: 0, scale: 0});
                    gsap.set(packs, {x: "9%", scale: 1.2});

                    gsap.to(logo, {autoAlpha: 1, scale: 1, duration: 1.5});
                    gsap.to(item1, {autoAlpha: 1, y: "0", duration: 1.5});
                    gsap.to(item2, {autoAlpha: 1, y: "0", duration: 1.5});
                    gsap.to(label, {autoAlpha: 1, scale: 1, duration: 1.5});
                    gsap.to(packs, {x: 0, scale: 1, duration: 1});

                    ScrollTrigger.batch(batch, {
                        start: "top 70%",
                        onEnter: batch => gsap.to(steps, {autoAlpha: 1, stagger:{each: -0.3, ease: "power.out"}, duration: 0.3, y: "0",
                        onComplete: function () {
                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: element,
                                    start: "top top",
                                    scrub: true
                                }
                            });
        
                            tl.to(packs, {x: "9%", scale: 1.2});
                        }})
                    })
                }

                if (element.classList.contains("js-fade-anim")) {
                    const fadeAnimEls = document.querySelectorAll(".js-fade-to-top");

                    if (fadeAnimEls.length > 0) {
                        Array.prototype.forEach.call(fadeAnimEls, function (fadeEl) {
                            gsap.set(fadeEl, {
                                y: "1.6rem",
                                autoAlpha: 0
                            });

                            const tl = gsap.timeline({
                                scrollTrigger: {
                                    trigger: fadeEl,
                                    start: "top 75%",
                                    onEnter: function () {
                                        gsap.to(fadeEl, {
                                            y: 0,
                                            autoAlpha: 1,
                                            duration: 0.5
                                        });
                                    }
                                }
                            });
                        });
                    }
                }

                if (element.classList.contains("js-trigger-nav")) {
                    const activeName = document.querySelector(".js-active-name");

                    const setActive = function (link) {
                        const paddingLeft = getComputedStyle(extraMenu).paddingLeft || 0;
                        links.forEach(el => el.parentNode.classList.remove("js-active"));
                        link.parentNode.classList.add("js-active");
                        const scroll = link.parentNode.offsetLeft - parseInt(paddingLeft, 10);
                        menu.scrollLeft = scroll;

                        if (activeName) {
                            activeName.textContent = link.textContent;
                        }
                    };

                    const menu = element.querySelector(".js-trigger-menu");
                    let links = gsap.utils.toArray(".js-trigger-nav-link"); // eslint-disable-line

                    const getHeaderHeight = function () {
                        const height = itsoftApp.commonVars.headerHeight || itsoftApp.utils.getHeaderHeight();
                        return height;
                    }

                    let mm = gsap.matchMedia();
                    let extraMenu = document.querySelector(".js-extra-menu");
                    let navHeight = function () {
                        return extraMenu.offsetHeight;
                    }

                    const withNav = document.querySelector(".js-with-nav");

                    ScrollTrigger.create({
                        trigger: withNav,
                        onEnter: function () {
                            extraMenu.classList.add("js-active-nav");
                        },
                        onLeave: function () {
                            extraMenu.classList.remove("js-active-nav");
                        },
                    })

                    links.forEach(a => {
                        let element = document.querySelector(a.getAttribute("href"));
                        ScrollTrigger.create({ // eslint-disable-line
                            trigger: element,
                            start: "top top+=" + (getHeaderHeight() + 6 + navHeight()),
                            end: "bottom top+=" + (getHeaderHeight() + 6 + navHeight()),
                            onToggle: self => self.isActive && setActive(a)
                            // markers: true
                        });
                    });
                }
            }
        };

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, gsapLibraries.gsap);
    };

    const disclaimer = document.querySelector(".disclaimer");
    // const disclaimerActive = disclaimer && itsoftApp.modules.cookie.getCookie(disclaimer);
    // if (!disclaimerActive) {
        disclaimer && initScrollActions(disclaimer);
    // }

    module.callback = initScrollActions;
});